<template>
  <b-row >
    <b-col
      class="col-12 col-sm-6 col-md-6 col-lg-3 col-xxl-3"
      v-for="content, index in contents"
      :key="index"
    > 
      <b-card
        no-body
        style="box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1) !important"
        class="card hover-card card-image-content card-type-content"
      >
      <b-link @click="$emit('action-add-form', content)">
        <video
          v-if="content.content_type === 'story' && isVideo(content.image_content)"
          muted
          playsinline
          :ref="`video_animation_${index}`"
          :src="content.image_content"
          @mouseenter="playVideoContents(index)"
          @mouseleave="pauseVideo(index)"
          @error="errorLoad(content)"
          class="card-image-content"
        >
        </video>
        <b-img
          v-else
          :id="`view${index}`"
          class="card-image-content"
          :src="getPreview(content)"
          @error="errorLoad(content)"
        />
      </b-link>

      <div>
        <div class="mx-1 position-container-actions">
          <b-form-checkbox
            v-model="checked_uuids"
            :value="content.uuid"
            :checked="checked_uuids.includes(content.uuid)"
            @change="$emit('toggle-check', content.uuid)"
            class="custom-control-primary"
          >
          </b-form-checkbox>
          <div class="content-card-actions">
              <button
                :id="`edit_content${content.uuid}`"
                class="card-action-btn"
                @click="$emit('action-add-form', content)"
              >
                <feather-icon icon="EditIcon" size="14" />
                <b-tooltip :target="`edit_content${content.uuid}`" triggers="hover" placement="bottom">{{ $t('campaigns.editContent') }}</b-tooltip>
              </button>
              <template v-if="isInsightsEnabled(content)">
                <span class="card-action-divider"></span>
                <button
                  :id="`insights_content${content.uuid}`"
                  class="card-action-btn"
                  @click="$emit('action-insights', content)"
                >
                  <feather-icon icon="BarChart2Icon" size="14" />
                  <b-tooltip :target="`insights_content${content.uuid}`" triggers="hover" placement="bottom">{{ $t('campaigns.content_insights') }}</b-tooltip>
                </button>
              </template>
              <template v-if="content.can_delete">
                <span class="card-action-divider"></span>
                <button
                  :id="`delete_content${content.uuid}`"
                  class="card-action-btn card-action-btn--danger"
                  @click="$emit('action-remove', content.uuid)"
                >
                  <feather-icon icon="XCircleIcon" size="14" />
                  <b-tooltip :target="`delete_content${content.uuid}`" triggers="hover" placement="bottom">{{ $t('campaigns.deleteContent') }}</b-tooltip>
                </button>
              </template>
            </div>
          
        </div>
        <interactions
          :index="index"
          :content="content"
          @action-side-search="$emit('action-side-search', $event)"
          />
        </div>
      </b-card>
    </b-col>
    <div class="col-12 row m-0 p-0" v-if="loading_contents && contents.length < total_results">
      <b-col class="col-12 col-sm-6 col-lg-4 col-xl-3" v-for="i in 4" :key="i">
        <b-card class="card-skeleton">
          <b-skeleton class="skeleton profile-avatar mb-2"></b-skeleton>
          <b-skeleton class="skeleton h1 col-10"></b-skeleton>
          <b-skeleton class="skeleton col-8 mb-5"></b-skeleton>

          <b-skeleton class="skeleton col-4"></b-skeleton>
          <b-skeleton class="skeleton col-4 mb-7"></b-skeleton>

          <div class="d-flex w-100 mb-1">
            <b-skeleton type="button" class="skeleton w-100 mr-2"></b-skeleton>
            <b-skeleton type="button" class="skeleton w-100 ml-2"></b-skeleton>

          </div>
        </b-card>
      </b-col>
    </div>
    <b-col class="col-12 text-center all-results-loaded-text" v-if="!loading_contents && contents.length > 0 && contents.length >= total_results">
      <feather-icon icon="CheckIcon" size="16" class="mr-50"/>
      <span>{{ $t('campaigns.allResultsLoaded') }}</span>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard, BImg, BLink, BFormCheckbox, BSkeleton, BTooltip
} from 'bootstrap-vue'
import service_campaign from "@/services/campaign";
import Interactions from './Interactions.vue';
import { getMotivationalPhrase } from '@/libs/utils/others'
import { isVideo } from '@/libs/utils/formats';
import { verifyAsset, } from '@/libs/utils/urls'


export default {
  name: 'ContentsView',
  components: {
    BRow,
    BCol,
    BCard,
    Interactions,
    BImg,
    BLink,
    BFormCheckbox,
    BSkeleton,
    BTooltip
  },
  props: {
    checked_uuids: {
      type: Array,
      default: () => [],
    },
    filter_networks: {
      type: Array,
      default: () => [],
    },
    filter_category: {
      type: String,
    },
    query_search: {
      type: String,
    },
    per_page: {
      type: Number,
    }
  },

  data() {
    return {
      verifyAsset,
      isVideo,
      getMotivationalPhrase,
      contents: [],
      backgroundDefault: require("@/assets/images/dashboard/reload_img.svg"),
      interval_loading: null,
      current_page: 1,
      total_results: 0,
      loading_contents: false,
      statuses: ['content_published'],
    }
  },
  computed: {
    filters() {
      return {
        statuses: this.statuses,
        category: this.filter_category,
        networks: this.filter_networks,
        query: this.query_search,
      };
    }
  },
  mounted() {
    window.addEventListener('scroll', this.checkScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.checkScroll);
  },
  created () {
    this.loading_contents = true;
    this.$vs.loading({
      type: 'sound',
      background: 'rgba(255, 255, 255, 1)',
      text: getMotivationalPhrase(),
    });

    this.interval_loading = setInterval(() => {
      const prev_loading = document.getElementsByClassName('con-vs-loading')[0]

      if (prev_loading) {
        prev_loading.classList.add('fade-out');
        setTimeout(function() {
          prev_loading.remove()
        }, 500);

        this.$vs.loading({
          type: 'sound',
          background: 'rgba(255, 255, 255, 1)',
          text: getMotivationalPhrase(),
        });
      }
    }, 5000);
    this.getContentsManage()
  },
  methods: {
    getContentsManage() {
      this.loading_creators = true;

      service_campaign.getContentsManage(this.$route.params.uuid, this.current_page, this.per_page, this.filters).then((response) => {
        const total_contents = this.formatContents(response.results);
        this.contents = total_contents;
        this.total_results = response.count;
        setTimeout(() => {        
          clearInterval(this.interval_loading)
          this.$vs.loading.close();
          this.loading_contents = false;
        }, 500);
      })
    },
    playVideoContents(index) {
      const video = this.$refs[`video_animation_${index}`][0];
      if (video && video.play) {
        video.play().catch(err => {
          console.warn('No se pudo reproducir el video:', err);
        });
      }
    },
    pauseVideo(index) {
      const video = this.$refs[`video_animation_${index}`][0];
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    },
    checkScroll() {
      const scrollableHeight = document.body.scrollHeight - window.innerHeight;
      const scrollPosition = window.scrollY;

      const load_more = scrollableHeight - scrollPosition <= 100 && !this.loading_contents && this.contents.length < this.total_results;

      if (load_more) {
        this.loading_contents = true;
        this.current_page += 1;
        this.getScrollInfinite();
      }
    },
    getScrollInfinite() {
      service_campaign.getContentsManage(this.$route.params.uuid, this.current_page, this.per_page, this.filters).then((response) => {
        const total_contents = this.formatContents(response.results);
        this.contents = [...this.contents, ...total_contents];
        this.total_results = response.count;
      })
        .finally(() => {
          this.loading_contents = false;
        });
    },
    getPreview(content) {
      const preview = content.content_preview_url;

      if (content.content_type === 'story') {
        return verifyAsset(content.image_content);
      } else if (preview && content.content_type !== 'story') {
        return preview;
      } else {
        return this.backgroundDefault;
      }
    },
    errorLoad(content) {

      if (content.content_type !== 'story') {
        content.content_preview_url = this.backgroundDefault;
      } else {
        service_campaign.getImageUpdatedContent(content.uuid).then((response) => {
          const img_new = response.image_content;
          content.image_content = img_new;
        });
      }
    },
    getMetrics(content) {
      const metrics = [
        {name: 'number_of_likes', value: content.number_of_likes},
        {name: 'number_of_comments',  value: content.number_of_comments},
        {name: 'number_of_shares', value: content.number_of_shares},
        {name: 'number_of_rts', value: content.number_of_rts},
        {name: 'number_of_times_favs', value: content.number_of_times_favs},
        {name: 'number_of_times_saved', value: content.number_of_times_saved},
        {name: 'number_of_views', value: content.number_of_views},  
        {name: 'number_of_dislikes', value: content.number_of_dislikes},
        {name: 'number_of_clicks_to_stickers', value: content.number_of_clicks_to_stickers},
        {name: 'number_of_clicks_to_the_link', value: content.number_of_clicks_to_the_link},
        {name: 'number_of_reproductions', value: content.number_of_reproductions},
        {name: 'number_of_impressions', value: content.number_of_impressions},
        {name: 'number_of_prints', value: content.number_of_prints},
        {name: 'number_of_responses', value: content.number_of_responses},
        {name: 'scope_number', value: content.scope_number},
        {name: 'number_of_interactions', value: content.number_of_interactions},
      ]
      return metrics.filter((item) => item.value > 0 && item.value !== null)
    },
    getUrlContent(content) {
      if (content.url_info) return content.url_info
      else if (content.image_content) return content.image_content
      return ''
    },
    getNetworkByUrl(url) {
      if (url.includes('instagram.com')) return 'instagram'
      else if (url.includes('spotify.com')) return 'spotify'
      else if (url.includes('twitter.com')) return 'twitter'
      else if (url.includes('facebook.com')) return 'facebook'
      else if (url.includes('youtube.com')) return 'youtube'
      else if (url.includes('twitch.tv')) return 'twitch'
      else if (url.includes('tiktok.com')) return 'tiktok'
      else return 'brandme'
    },
    isInsightsEnabled(content) {
      return !!(
        content.deal &&
        content.deal.has_advanced_insights &&
        content.deal.video_id &&
        content.deal.is_video_linked &&
        content.status === 'content_published'
      )
    },
    formatContents(contents) {
      const data = [];
      contents.forEach(content => {
        const url = this.getUrlContent(content);
        content['network_by_url'] = this.getNetworkByUrl(url);
        content['metrics'] = this.getMetrics(content);

        data.push(content);
      });

      return data;
    }

  },
  watch: {
    filter_category: {
      handler() {
        this.getContentsManage();
      },
    },
    filter_networks: {
      handler() {
        this.getContentsManage();
      },
      deep: true,
    },
    query_search: {
      handler() {
        this.getContentsManage();
      },
    },
  }
}
</script>

<style scoped lang="scss">
.content-card-actions {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 9;
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.96);
  border-radius: 20px;
  padding: 4px 6px;
  gap: 2px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  opacity: 0;
  transition: opacity 0.2s ease;
}
.card-type-content:hover .content-card-actions {
  opacity: 1;
}
.card-action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: none;
  background: transparent;
  color: #3b3b45;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
  padding: 0;
}
.card-action-btn:hover:not(:disabled) {
  background: rgba(0, 0, 0, 0.08);
}
.card-action-btn--danger:hover:not(:disabled) {
  background: rgba(234, 84, 85, 0.15);
  color: #ea5455;
}
.card-action-divider {
  width: 1px;
  height: 16px;
  background: rgba(0, 0, 0, 0.1);
  margin: 0 2px;
}
.card-skeleton {
  background-color: #fff;
  .card-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
    border-radius: .4rem;
  }
  .skeleton {
    &.profile-avatar {
      width: 200px;
      height: 200px;
      border-radius: 100%;
    }
  }
}
.position-container-actions {
  position: relative;
  bottom: 20.5em;;
  z-index: 9
}
.hover-card:hover {
  transform: scale(1.05);
  transition: all 500ms;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 12px 28px 0px,
    rgba(0, 0, 0, 0.1) 0px 2px 4px 0px,
    rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset;
}
.card-image-content {
  width: 100%;
  object-fit: cover;
  height: 300px;
  border-radius: 1%;
}
.card-type-content{
 display: flex;
 height: 90%;
 border: 1px solid #eee5e5;
}
.all-results-loaded-text {
  color: #7F7F7F;
  font-size: 0.9rem;
  padding: 1.5rem 0;
}
</style>
